import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { BeatLoader } from 'react-spinners';
import moment from 'moment';
import Modal from 'react-modal';
import { get } from "../../../server/actionsParent";
import AccountHistory from "../../SchoolAdmin/PaymentReports/AccountHistory";
import { getGradeNumberByText, gradeTextToNumber,
    getModuleEnum,
    getAccessLevelByModule, getSchoolGrades, groupBy } from "../../../server/util";
import { URL_VERSION } from '../../../server/constants';
const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '75%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
const modEnum=getModuleEnum();
const defaultImg=require('../../../assets/img/student-icon.png')
class viewStudent extends Component {
    componentWillMount = () => {
        // alert(JSON.stringify(this.context.router.route.match, null, 2))
        const { id } = this.context.router.route.match.params;
        const { schoolId, orderStatus, lunchBal, schoolYear } = this.context.router.route.location.state;        
        // alert(id)
        this.setState({ loading: true, schoolId: schoolId, orderStatus: orderStatus, lunchBal: lunchBal, schoolYear:schoolYear });
        get('/studentUsers/' + id + '?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let studentData = data || {};
            console.log(JSON.stringify(studentData, null, 2))
            //alert(JSON.stringify(studentData._links.mealSchool.href));
            get('/studentUsers/' + studentData._links.self.href.split('/').pop() + '/mealSchool?access_token=').then((response) => {
                if (!response.ok) {
                    this._addNotificationError();
                    throw Error(response.statusText);
                }
                return response.json();
            }).then((data) => {
                // alert("came here")
                studentData.schoolName = data.schoolName;
                studentData.isPaymentEnabled = data.isPaymentEnabled
                studentData.mealSchoolId = data._links.self.href.split("/").pop();
                this.setState({
                    studentData: studentData, loading: false
                }, this.getStudentExtraInfo(studentData)
                )
            }).catch(
                (error) => {
                    this.setState({ loading: false });
                    console.log('Parent dashboard error', error);
                }
            );
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('Parent dashboard error', error);
            }
        );
    };
    getStudentExtraInfo = (student) => {
        student.id = student._links.self.href.split('/').pop();
        let d = new Date();
        let date = {};
        date.month = d.getMonth() + 2;
        date.year = d.getFullYear();
        let mealMonth = date.year + '' + (('0' + date.month).slice(-2));
        get(URL_VERSION + '/menuOrderStatus?studentRecId=' + student.id + '&yearMonth=' + mealMonth + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log("oRDER " + data)
            if (data.orderStatus === true) {
                student.orderStatus = "update"
            } else if (data.orderStatus === false) {
                student.orderStatus = "new"
            } else {
                student.orderStatus = 0;
            }
            this.setState({
                studentData: student,
                loading: false
            })
        }).catch(
            (error) => {
                console.log('Get Meal Menu response', error)
            }
        );
    }
    constructor(props) {
        super(props);
        this.state = {
            studentData: {},
            modalIsOpen: false,
            schoolId: 0,
            orderStatus: "",
            lunchBal: 0,
            loading: false,
            schoolYear:'',
            grade:''
        }
    }
    gotoBack = (e) => {
        e.preventDefault();
        let _self = this;
        _self.context.router.history.goBack();
    }
    render() {
        const gradeGroup=groupBy(getSchoolGrades(this.state.schoolId),'value');
        const label=((gradeGroup[(this.state.studentData||{}).gradeName]||[])[0]||{}).label;
        return (
            <section className="full-width clearfix">
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container ">
                    <div className="sectionTitle">
                        <div className="row">
                            <div className="col-md-6 col-sm-6 col-sm-6">
                                <h2 style={{ width: 'auto' }}>
                                    <span>Student Details</span>
                                </h2>
                            </div>
                            <div className="col-md-6 col-sm-6 col-sm-6" style={{ marginTop: '15px' }}>
                                <button className="pull-right btn bg-color-4" style={{ margin: '0px', color: '#ffffff' }} onClick={(e) => this.gotoBack(e)}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                            </div>
                        </div>
                    </div>
                    {(this.state.studentData) ?
                        <div className="row">
                            <div className="col-md-6 col-md-offset-3 col-sm-12 col-xs-12 blog-full">
                                <div className="media courseList">
                                    <a className="media-left" style={{ width: '150px', height: '150px', margin: '15px' }}>
                                        <img className="media-object" style={{ width: '150px', height: '150px' }}
                                            src={(this.state.studentData.image||'')===''?defaultImg:this.state.studentData.image}
                                            alt="Student image" />
                                    </a>
                                    <div className="media-body capitalize">
                                        <h3 className="media-heading"><a href="single-blog-left-sidebar.html" style={{ marginBottom: '0px' }}
                                            className="color-1">{(this.state.studentData.firstName || '') + ' ' + (this.state.studentData.lastName || '')}</a>
                                        </h3>
                                         <Link to={{
                                            pathname: '/parent/accountHistory/' + this.state.studentData.id,
                                            state:{
                                                schoolId:this.state.schoolId,
                                            }
                                        }} className="btn btn-sm btn-primary"
                                            style={{ margin: '5px 0px', padding: '5px' }}><i
                                                className="fa fa-list-alt"></i> <span>Account History</span></Link>
                                        {
                                        getAccessLevelByModule(modEnum.BACP,this.state.schoolId)?
                                        <Link to={{
                                            pathname: '/parent/bcacReport/' + this.state.studentData.id,
                                            state:{
                                                schoolId:this.state.schoolId,
                                                schoolYear:this.state.schoolYear,
                                                studentName:(this.state.studentData.firstName || '') + ' ' + (this.state.studentData.lastName || '')
                                                }
                                            }} className="btn btn-sm btn-success bg-color-3"
                                            style={{ margin: '5px 0px', padding: '5px' }}><i
                                            className="fa fa-eye"></i> <span>BCAC Report</span></Link>
                                            :null}
                                        
                                        <br />
                                        <label className="color-3">Grade : {label}</label>
                                        <br />
                                        <label className="color-3">School
                                            : {this.state.studentData.schoolName}</label><br />
                                        <div className="modal-footer row student-modal-footer-btns">
                                                <Link to={{
                                                    pathname: '/parent/menu/' + this.state.studentData.id + '/' + this.state.orderStatus,
                                                    state: {
                                                        schoolId: this.state.schoolId,
                                                        lunchBal: this.state.accBalance
                                                    }
                                                }} className="btn btn-sm btn-success pull-left"
                                                    style={{ margin: '0px' }}
                                                ><i
                                                    className="fa fa-cutlery"></i> <span>Order Meals</span>
                                                </Link>                                                                                           
                                                <Link to={{
                                                    pathname: '/parent/orders/' + this.state.studentData.id,
                                                    state:{
                                                        schoolId: this.state.schoolId,
                                                    }
                                                }} className="btn btn-sm btn-success pull-right"
                                                    style={{ margin: '0px' }}><i
                                                        className="fa fa-eye"></i> <span>View Orders</span></Link>
                                                 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : ''}
                      {/* <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={() => this.setState({modalIsOpen: false})}
                        style={modalStyles}
                        contentLabel="Activation"
                        ariaHideApp={false}
                        >
                        <div className="modal-header row">
                                    <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">{'Account History : '+this.state.studentData.firstName+' '+this.state.studentData.lastName}</h4>                                
                                    <div className="col-md-6"><button type="button" className="pull-right color-1" onClick={() => {this.setState({modalIsOpen: false})}}>X</button></div>
                            </div>
                            <div className="modal-body">
                            <div className="row">                        
                            <AccountHistory student={this.state.studentData}  filterData={this.state.hdataFilter} />
                            </div>
                            </div>
                        </Modal>  */}
                </div>
            </section>
        );
    }
}

viewStudent.contextTypes = {
    router: PropTypes.object.isRequired
}
export default viewStudent;


// WEBPACK FOOTER //
// ./src/components/Parent/OrderMeals/viewStudent.jsx